import(/* webpackMode: "eager" */ "/home/das/web/crowdvault.digitas.my/nodeapp/src/app/kyc-status/page.tsx");
